var n = function(i) {
  return typeof window < "u" ? i in window : !1;
};
export {
  n as i
};
